"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Плагин для преобразования запросов за урлом бандла расширения в урл из манифеста хоста
 */
const runtimePlugin = () => {
    return {
        name: '@vk-tech-solar/loader-module-federation',
        beforeRequest(args) {
            const globalObj = (typeof window === 'undefined' ? global : window);
            args.options.remotes.forEach((remote) => {
                // @ts-ignore
                const name = (remote.entry.match(/(.*?)\[(.+?)](.*)/) ?? [])[2];
                const targetName = name ?? remote.alias;
                // @ts-ignore
                remote.entry =
                    (globalObj.solar?.getExtensionLoaderInfo
                        ? globalObj.solar?.getExtensionLoaderInfo(targetName, '@vk-tech-solar/loader-module-federation')
                        : globalObj.solar?.getExtensionLoaderInfoCustom?.(targetName, '@vk-tech-solar/loader-module-federation'))?.options?.url ??
                        // @ts-ignore
                        remote.entry;
            });
            return args;
        },
    };
};
exports.default = runtimePlugin;
